let loadingPromise;

export function loadRecaptcha(siteKey) {
  if (!siteKey) return Promise.resolve();
  if (window.grecaptcha) return Promise.resolve();
  if (!loadingPromise) {
    loadingPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("reCAPTCHA failed to load"));
      document.head.appendChild(s);
    });
  }
  return loadingPromise;
}

// Returns a token, or "" if no site key configured (graceful degrade).
export async function getRecaptchaToken(siteKey, action) {
  if (!siteKey) return "";
  try {
    await loadRecaptcha(siteKey);
    return await new Promise((resolve, reject) =>
      window.grecaptcha.ready(() =>
        window.grecaptcha.execute(siteKey, { action }).then(resolve, reject)
      )
    );
  } catch {
    return "";
  }
}
